/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { ErrorMessageEnum } from './error-message.enum';
import { StandardIntervalModel } from '../../time-interval/model/standardInterval.model';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';
import { TIME_PATTERN_FULL } from '@irian-ro/constants';

export const standardTimeIntervalValidator = (
  standardInterval: StandardIntervalModel
): ValidatorFn => {
  return (control: AbstractControl): ErrorModel | null => {
    let errors: ErrorModel | null = null;

    const timeFormat = new RegExp(/^(\d|[0-1]\d|[2][0-3]):[0-5]\d(:[0-5]\d)?$/);
    const standardStartTime = moment(
      standardInterval.startTime,
      TIME_PATTERN_FULL
    );
    const standardEndTime = moment(standardInterval.endTime, TIME_PATTERN_FULL);

    if (
      control.value.startTime === null ||
      control.value.startTime === undefined ||
      control.value.startTime === ''
    ) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: ErrorMessageEnum.missingStartTime,
      };
    } else if (
      control.value.endTime === null ||
      control.value.endTime === undefined ||
      control.value.endTime === ''
    ) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: ErrorMessageEnum.missingEndTime,
      };
    } else if (timeFormat.test(control.value.startTime) === false) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: ErrorMessageEnum.invalidStartTime,
      };
    } else if (timeFormat.test(control.value.endTime) === false) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: ErrorMessageEnum.invalidEndTime,
      };
    } else if (
      moment(control.value.startTime, TIME_PATTERN_FULL).isAfter(
        moment(control.value.endTime, TIME_PATTERN_FULL)
      )
    ) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: ErrorMessageEnum.startTimeAfterEndTime,
      };
    } else if (
      !moment(control.value.startTime, TIME_PATTERN_FULL).isBetween(
        standardStartTime,
        standardEndTime,
        null,
        '[]'
      )
    ) {
      errors = {
        severity: ErrorSeverityEnum.warning,
        message: ErrorMessageEnum.startTimeNotStandard,
      };
    } else if (
      !moment(control.value.endTime, TIME_PATTERN_FULL).isBetween(
        standardStartTime,
        standardEndTime,
        null,
        '[]'
      )
    ) {
      errors = {
        severity: ErrorSeverityEnum.warning,
        message: ErrorMessageEnum.endTimeNotStandard,
      };
    }

    (control as FormGroup).controls['startTime'].setErrors(errors);
    (control as FormGroup).controls['endTime'].setErrors(errors);

    return errors ? errors : null;
  };
};
